import { useContext, useMemo } from "react";
import { LivePayoutsContext } from "../contexts/LivePayoutsContext";
import dayjs from "dayjs";
import { isPeriod } from "../helpers/enumUtils";
import { isProduct } from "../helpers/enumUtils";
export const useLivePayouts = (scope) => {
    const livePayouts = useContext(LivePayoutsContext);
    return useMemo(() => {
        if (isPeriod(scope)) {
            const afterThan = dayjs().startOf(scope);
            return livePayouts === null || livePayouts === void 0 ? void 0 : livePayouts.filter(payout => dayjs(payout.timestamp).isAfter(afterThan));
        }
        if (isProduct(scope)) {
            return livePayouts === null || livePayouts === void 0 ? void 0 : livePayouts.filter(payout => payout.product === scope);
        }
        return livePayouts;
    }, [livePayouts, scope]);
};
